import React, { Suspense } from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import LoginAsUser from "../../../components/loginasuser/LoginAsUser";
import { allLogs, commonText } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

const AllLogsTable = React.lazy(
  () =>
    import(
      "../../../components/table/all-tables/logstable/all-logs/AllLogsTable"
    )
);

const AllLogs = () => {
  return (
    <>
      <LoginAsUser />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <TablePagesTitle
          mainTitle={allLogs.mainTitle}
          content={allLogs.content}
        />
        <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
          <AllLogsTable />
        </Suspense>
      </ErrorBoundary>
    </>
  );
};

export default AllLogs;
